import AppChildrenIndex from "./child.vue";
import AppChildrenList from "./list/list.vue";
import AppChildrenItem from "./item/item.vue";

const routes = [
  {
    path: "child",
    component: AppChildrenIndex,
    meta: {
      auth: {
        roles: "child.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "child.index",
        component: AppChildrenList,
        meta: {
          auth: {
            roles: "child.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "child.create",
        component: AppChildrenItem,
        meta: {
          auth: {
            roles: "child.create",
            redirect: { name: "child.index" }
          }
        }
      },
      {
        path: ":id",
        name: "child.edit",
        component: AppChildrenItem,
        meta: {
          auth: {
            roles: "child.update",
            redirect: { name: "child.index" }
          }
        }
      }
    ]
  }
];

export default routes;
